export default "__VITE_ASSET__b79624d6__"